import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"

export const OAuthConsentContainer = styled(FlexContainer)({
  gridArea: "content",
  overflow: "auto",
  height: "100%",
  background: "#1c2127",
})

export const OAuthCard = styled(FlexContainer)({
  background: "#252a31",
  padding: "40px",
  borderRadius: "8px",
  maxWidth: "400px",
  width: "100%",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
})

export const Title = styled.span({
  color: "#f5f8fa",
  fontSize: "20px",
  fontWeight: 500,
})

export const ErrorTitle = styled.span({
  color: "#f5f8fa",
  fontSize: "18px",
})

export const SubText = styled.span({
  color: "#a7b6c2",
  fontSize: "14px",
})

export const ButtonRow = styled(FlexContainer)({
  gap: "15px",
  justifyContent: "center",
  width: "100%",
})

export const DetailsList = styled.div({
  width: "100%",
  background: "#1c2127",
  borderRadius: "6px",
  padding: "12px 16px",
  fontSize: "13px",
  color: "#a7b6c2",
})

export const DetailRow = styled.div({
  display: "flex",
  justifyContent: "space-between",
  padding: "4px 0",
  "& span:first-of-type": {
    color: "#8a9ba8",
  },
  "& span:last-of-type": {
    color: "#f5f8fa",
    fontFamily: "monospace",
    fontSize: "12px",
  },
})
